import React from "react";

import _ from "lodash";

const DropDown = ({ input, meta, items, ...otherProps }) => (
  <div className="form-group input-group">
    {otherProps.label && <label>{otherProps.label}</label>}

    <select
      {...input}
      onChange={input.onChange}
      className={`custom-select form-control ${
        meta.error && meta.touched ? "is-invalid" : ""
      }`}>
      {!_.isNil(otherProps.placeholder)
        ? _.concat(
            <option key={-1} value="">
              {otherProps.placeholder}
            </option>,
            items
          )
        : items}
    </select>
    {meta.error && meta.touched && (
      <div className="invalid-feedback">{meta.error}</div>
    )}
  </div>
);

export { DropDown };
